import ModuleWrapper from '@/components/page/ModuleWrapper';

const Analytics = () => import(/* webpackChunkName: "analytics" */ '@/views/Analytics/Analytics');
const meta = (data = {}) => ({
    moduleName: 'analytics',
    auth: true,
    ...data,
});

export default [{
    path: 'analytics',
    component: ModuleWrapper,
    meta: meta({
        title: 'Analytics',
    }),
    children: [
        {
            path: '',
            name: 'Analytics',
            component: Analytics,
            props: true,
            meta: meta({}),
        },
    ],
}];
